import { Trans } from "react-i18next";
import ReferCelebrateIcon from "../icons/refer-a-friend/ReferCelebrateIcon";
import ShareIcon from "../icons/refer-a-friend/ShareIcon";
import SignUpIcon from "../icons/refer-a-friend/SignUpIcon";
import TalksIcon from "../icons/refer-a-friend/TalksIcon";
import { t } from "i18next";

const Arrow: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 8"
    fill="none"
    {...props}
  >
    <path
      d="M31.3536 4.35355C31.5488 4.15829 31.5488 3.84171 31.3536 3.64645L28.1716 0.464466C27.9763 0.269204 27.6597 0.269204 27.4645 0.464466C27.2692 0.659728 27.2692 0.976311 27.4645 1.17157L30.2929 4L27.4645 6.82843C27.2692 7.02369 27.2692 7.34027 27.4645 7.53553C27.6597 7.7308 27.9763 7.7308 28.1716 7.53553L31.3536 4.35355ZM0 4.5H31V3.5H0V4.5Z"
      fill="#74DFAC"
    />
  </svg>
);

const Banner = () => {
  const steps = [
    {
      icon: ShareIcon,
      text: (
        <p
          className={
            "lg:text-xs md:text-14px font-normal text-white lg:text-center"
          }
        >
          <Trans
            i18nKey="refer_a_friend.share_code"
            components={{ b: <b className={"font-bold"} /> }}
          />
        </p>
      ),
    },
    {
      icon: TalksIcon,
      text: (
        <p
          className={
            "lg:text-xs md:text-14px font-normal text-white lg:text-center"
          }
        >
          <Trans
            i18nKey="refer_a_friend.friend_talks"
            components={{ b: <b className={"font-bold"} /> }}
          />
        </p>
      ),
    },
    {
      icon: SignUpIcon,
      text: (
        <p
          className={
            "lg:text-xs md:text-14px font-normal text-white lg:text-center"
          }
        >
          <Trans
            i18nKey="refer_a_friend.sign_up"
            components={{ b: <b className={"font-bold"} /> }}
          />
        </p>
      ),
    },
    {
      icon: ReferCelebrateIcon,
      text: (
        <p
          className={
            "lg:text-xs md:text-14px font-normal text-white lg:text-center"
          }
        >
          <Trans
            i18nKey="refer_a_friend.celebrate"
            components={{ b: <b className={"font-bold"} /> }}
          />
        </p>
      ),
    },
  ];
  return (
    <div
      className={
        "flex flex-col md:flex-row md:justify-between lg:justify-center md:gap-4 lg:gap-0"
      }
    >
      {steps.map((r, idx) => {
        return (
          <div className={"flex w-full mb-3"}>
            <div
              key={"banner-item-" + idx}
              className={
                "flex flex-row md:flex-col lg:flex-1 relative items-center"
              }
            >
              <r.icon className={"w-16 h-auto aspect-square"} />
              <div
                className={"flex flex-col gap-1 lg:items-center w-full mt-4"}
              >
                <p
                  className={"w-full md:text-center text-[--green100] text-xs"}
                >
                  {idx > 2
                    ? t("refer_a_friend.finally", { defaultValue: "Finally !" })
                    : `${t("book_exam.step", { defaultValue: "Step" })} ${
                        idx + 1
                      }`}
                </p>
                {r.text}
              </div>
            </div>
            {idx < 3 && (
              <Arrow
                className={
                  "fill-socials-whatsapp hidden mx-1 w-auto h-4 xl:mx-0 lg:block self-start lg:mt-6 lg:mb-4 xl:mb-0"
                }
              />
            )}
          </div>
        );
      })}
    </div>
  );
};
export default Banner;
